import { ChangeEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { searchUser } from "../../../features/searchSlice";

const SearchBar = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState<string>("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    dispatch(searchUser(e.target.value));
  };

  return (
    <div className="border rounded-full h-[40px] w-full overflow-hidden flex items-center focus-within:border-violet-500">
      <div className="w-[45px] h-full flex justify-center items-center">
        <i className="fa-solid fa-magnifying-glass text-slate-400"></i>
      </div>
      <input
        type={"text"}
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => handleChange(e)}
        className="w-full h-full outline-none text-sm"
      ></input>
    </div>
  );
};

export default SearchBar;
